import { FieldSchema } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";

export const createdAt: FieldSchema = {
  name: "createdAt",
  dataTransform: {
    toGraphql: undefined,
  },
  display: {
    displayed: false
  },
  form: { label: "Created at", disabled: true, displayed: false },
  grid: {
    displayed: true,
    order: 66,
    label: "Creation Date",
    ignoredForSearch: true,
    // Set explicitly: the field carries no `data` block (it is never written), so the filter
    // type cannot be derived from data.type and would otherwise fall back to TEXT. The DATE
    // filter also drives the DATE render slot, which formats the stored ISO string.
    filter: GridFilterTypes.DATE,
  },
};
